import { FC } from 'react'

import { LinkProps } from '../Link'

import * as SC from './styled'

export type MapModalProps = {
  className?: string
  title: string
  address: string
  category: string
  date: string
  link: LinkProps
  display: boolean
  position: { lat: number; lng: number }
  onClose: () => void
}

const MapModal: FC<MapModalProps> = ({
  title,
  address,
  category,
  date,
  link,
  position,
  onClose,
}) => {
  return (
    <SC.WindowInfo position={position} onCloseClick={onClose}>
      <SC.WindowInfoWrapper>
        <SC.WindowInfoTitle>{title}</SC.WindowInfoTitle>
        <SC.WindowInfoAddress>{address}</SC.WindowInfoAddress>
        <SC.WindowInfoCategory>{category}</SC.WindowInfoCategory>
        <SC.WindowInfoPublicationDate>{date}</SC.WindowInfoPublicationDate>
        <SC.ReadMoreLink {...link} />
      </SC.WindowInfoWrapper>
    </SC.WindowInfo>
  )
}

export default MapModal
